import { render, staticRenderFns } from "./PartnerSetting.vue?vue&type=template&id=6bbbeca3"
import script from "./PartnerSetting.vue?vue&type=script&lang=js"
export * from "./PartnerSetting.vue?vue&type=script&lang=js"
import style0 from "./PartnerSetting.vue?vue&type=style&index=0&id=6bbbeca3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports